var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-list flex-start flex-center flex-wrap"},_vm._l((_vm.list),function(value,key){return _c('div',{key:key,staticClass:"image-item"},[_c('el-image',{staticClass:"image-show",attrs:{"src":value,"fit":"contain","preview-src-list":_vm.list}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }